/**
 * Settings module translations - Tabs section
 */

const tabs = {
  peppol: "Peppol",
  vatRegistration: "VAT Registration",
  salesTax: "Sales Tax",
  taxId: "Tax Id",
  bankDetails: "Bank Details",
  countrySpecifics: "Country specifics",
  registrationTracker: "Registration tracker",
};

export default tabs;
